import data from "../../../../../src/CircleBadge/CircleBadge.docs.json";
import * as React from 'react';
export default {
  data,
  React
};